// The four parent sections, in the order of the boards (MHome tabs, WebHome links) (FR-003, FR-005,
// FR-006). Shared by the mobile tab bar and the desktop navigation.
import type { ComponentType } from "react";

import { HomeIcon } from "@/ui/icons/HomeIcon";
import type { IconProps } from "@/ui/icons/LineIcon";
import { OrdersIcon } from "@/ui/icons/OrdersIcon";
import { ProfileIcon } from "@/ui/icons/ProfileIcon";
import { ShopIcon } from "@/ui/icons/ShopIcon";

export type ParentSection = {
  /** Route name inside `(parent)/(tabs)`. */
  name: "index" | "shop" | "orders" | "profile";
  href: "/" | "/shop" | "/orders" | "/profile";
  label: "Home" | "Shop" | "Orders" | "Profile";
  Icon: ComponentType<IconProps>;
};

export const parentSections: readonly ParentSection[] = [
  { name: "index", href: "/", label: "Home", Icon: HomeIcon },
  { name: "shop", href: "/shop", label: "Shop", Icon: ShopIcon },
  { name: "orders", href: "/orders", label: "Orders", Icon: OrdersIcon },
  { name: "profile", href: "/profile", label: "Profile", Icon: ProfileIcon },
];

/** The section an address belongs to (`/` only for Home; deeper addresses match their section). */
export function sectionForPath(pathname: string): ParentSection | null {
  if (pathname === "/") return parentSections[0] ?? null;
  return (
    parentSections.find(
      (s) =>
        s.href !== "/" &&
        (pathname === s.href || pathname.startsWith(`${s.href}/`)),
    ) ?? null
  );
}
